import { useQuery } from "@tanstack/react-query";
import { fetchPetAvatar } from "../enums/queryFunction/Fetch";
import { PET_AVATAR } from "../enums/QueryKeys";

export default function usePetAvatar(petId) {
  const { data, isLoading, error } = useQuery({
    queryKey: [PET_AVATAR, petId],
    queryFn: () => fetchPetAvatar(petId),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !!petId,
  });
  return { avatar: data, isLoading, error };
}
